/*
Suresh  09/23/2022  2699761741  UI Alignments in Side nav, Record Format Fixed
Sohel   10/12/2022  2699761741  Added breadcrumbs,label changes,pagination changes
Raghu 10/28/2022 2699761741 Button Styling Enhancements
 */
import React, {useContext} from 'react';
import {Button, Typography} from '@material-ui/core';
import {ThemeContext} from '../../../../themes/ThemeProvider';

function ConfirmationForm({closeDialog, setMainRunClicked}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const handleSubmit = () => {
    setMainRunClicked(true);
    closeDialog();
  };
  return (
    <>
      <div className="text-center mb-4">
        <Typography variant="h4">
          {`Are you sure want to run ?`}
        </Typography>
      </div>

      <div className="d-flex justify-content-center">
        <Button
          type="button"
          variant="outlined"
          className={`reset-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => closeDialog()}
        >
          Reset
        </Button>
        <Button
          type="submit"
          variant="outlined"
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => handleSubmit()}
        >
          Run
        </Button>
      </div>

    </>
  );
}

export default ConfirmationForm;
